import React from 'react';
import { useLanguage, useLocalizedNavigate, localizePath } from '../contexts/LanguageContext';
import events from '../data/events';

// Section de l'accueil qui mène vers les pages événements et destinations.
// Des liens <a href> réels, pour que Google découvre et valorise ces pages.
const EventsMinimal = () => {
  const navigate = useLocalizedNavigate();
  const { language } = useLanguage();

  return (
    <section id="evenements" style={{ background: '#000' }}>
      <div className="container-custom">
        <div className="section-header">
          <h2 className="section-title">
            {language === 'fr' ? 'Événements & destinations' : 'Events & destinations'}
          </h2>
          <p className="section-subtitle">
            {language === 'fr'
              ? 'Nos équipes vous accompagnent sur les grands rendez-vous et dans les lieux de villégiature les plus exposés.'
              : 'Our teams accompany you at major events and in the most exposed holiday destinations.'}
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(260px, 100%), 1fr))',
          gap: '1.5rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {events.map((event) => {
            const content = event[language];
            return (
              <a
                key={event.slug}
                href={localizePath(event.path, language)}
                onClick={(e) => { e.preventDefault(); navigate(event.path); }}
                style={{
                  display: 'block',
                  background: '#0a0a0a',
                  border: '1px solid #262626',
                  borderRadius: '8px',
                  padding: '2rem',
                  textDecoration: 'none',
                  transition: 'all 0.4s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#404040';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#262626';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{ fontSize: '0.75rem', letterSpacing: '2px', color: '#525252', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
                  {content.label}
                </div>
                <div style={{ fontSize: '1.35rem', fontWeight: 400, color: '#fff', marginBottom: '0.5rem' }}>
                  {content.name}
                </div>
                <div style={{ fontSize: '0.9rem', color: '#737373', fontWeight: 300 }}>
                  {content.period}
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EventsMinimal;
